import React from 'react'
import Helmet from '../components/Helmet/Helmet';
import Gc from '../components/Gc/Gc';

import publication_1 from '../assets/images/ceylon-today-2 (1).jpg'
import publication_2 from '../assets/images/momento-1-724x1024.jpg'
import publication_3 from '../assets/images/the-morning-1-940x1024.jpg'
import publication_4 from '../assets/images/the-morning-1024x798.jpg'
import publication_5 from '../assets/images/ceylon-today-1.jpg'
import publication_6 from '../assets/images/momento-2-724x1024.jpg'
import publication_7 from '../assets/images/ceylon-today-1024x627.jpg'
import publication_8 from '../assets/images/momento-1024x737.jpg'

import publication_9 from '../assets/images/2023_03_12_08_31_IMG_4754-copy.jpg'
import publication_10 from '../assets/images/2023_03_12_08_35_IMG_4761-copy.jpg'
import publication_11 from '../assets/images/2023_03_12_08_35_IMG_4762-copy.jpg'
import publication_12 from '../assets/images/2023_03_12_08_35_IMG_4763-copy.jpg'
import publication_13 from '../assets/images/2023_03_17_20_18_IMG_4982-copy.jpg'
import publication_14 from '../assets/images/2023_03_12_08_34_IMG_4759-copy.jpg'

const Publications = () => {

    const items1 = [
        { xs: 8, imgSrc: publication_1 },
        { xs: 4, imgSrc: publication_2 },
        { xs: 5, imgSrc: publication_3 },
        { xs: 7, imgSrc: publication_4 },
        { xs: 7, imgSrc: publication_5 },
        { xs: 5, imgSrc: publication_6 },
        { xs: 12, imgSrc: publication_7 },
        { xs: 7, imgSrc: publication_8 },
    ];
    const items2 = [
        { xs: 4, imgSrc: publication_9 },
        { xs: 4, imgSrc: publication_10 },
        { xs: 4, imgSrc: publication_11 },
        { xs: 4, imgSrc: publication_12 },
        { xs: 4, imgSrc: publication_13 },
        { xs: 4, imgSrc: publication_14 },
    ];

      
  return <Helmet title={'Publications'}>
  <section className='__black'>
    <div className="w-1">
      <h1 className='__h1' >Publications</h1>
      <span className='dash'></span>
    </div>
    <div className="w-1">
      <Gc style={{height:'80vh'}} items={items1} />
    </div>
    <div className="w-1">
      <h2 className='__h2 p__20'>Featured Images :​</h2>
      <Gc style={{height:'80vh'}} items={items2} />
    </div>
  </section>
  </Helmet>
}

export default Publications